module.exports = __webpack_public_path__ + "static/media/screener-lock-icon.cf86284b.svg";